'use client';

import {ComponentProps, forwardRef} from 'react';

import {
  App,
  AppType,
  NO_CATEGORY_CATEGORY,
  SelectionApp,
} from '@web-catalog/types';

import {chunk} from '@web-catalog/utils/helpers';

import {AppCard} from '@web-catalog/ui-kit/AppCard';
import {ArrowLink} from '@web-catalog/ui-kit/ArrowLink';
import {Scroller} from '@web-catalog/ui-kit/Scroller';

import styles from './AppsCarousel.module.scss';

export type Props = {
  title: string;
  appType: AppType;
  apps: Array<App | SelectionApp>;
  showLinkToAll: boolean;
  testId?: string;
  onSwipe?: ComponentProps<typeof Scroller>['onSwipe'];
};

const chunkSize = 3;

export const AppsCarousel = forwardRef<HTMLElement, Props>(
  ({title, apps, appType, showLinkToAll, testId, onSwipe}, ref) => {
    if (!apps.length) {
      return null;
    }
    const chunks = chunk(apps, 3);
    return (
      <section ref={ref} data-testid={testId}>
        <h2>{title}</h2>
        <Scroller onSwipe={onSwipe}>
          {chunks.map((apps, chunkIndex) => (
            <div className={styles.appsChunk} key={chunkIndex}>
              {apps.map((app, appIndex) => (
                <AppCard
                  key={app.appId}
                  app={app as ComponentProps<typeof AppCard>['app']}
                  position={chunkIndex * chunkSize + appIndex}
                  listName={title}
                />
              ))}
            </div>
          ))}
        </Scroller>
        {showLinkToAll && (
          <ArrowLink
            href={
              appType === AppType.GAMES
                ? `/games/${NO_CATEGORY_CATEGORY}`
                : `/${NO_CATEGORY_CATEGORY}`
            }
            direction="to-right"
            className={styles.arrowLink}
          >
            {appType === AppType.GAMES ? 'Все игры' : 'Все приложения'}
          </ArrowLink>
        )}
      </section>
    );
  },
);

AppsCarousel.displayName = 'AppsCarousel';
